export default __webpack_public_path__ + "images/Femur_Plane.7d50ccc1168c6aa52b0e4ecf411814b5.png";